export const ROLE_WATER = "ROLE_WATER";
export const ROLE_TIME = "ROLE_TIME";
export const ROLE_TIME_TEMP = "ROLE_TIME_TEMP";
export const ROLE_TIME_ADMIN = "ROLE_TIME_ADMIN";
export const ROLE_CUST_SUPP = "ROLE_CUST_SUPP";
export const ROLE_CUST_SUPP_ADMIN = "ROLE_CUST_SUPP_ADMIN";
export const ROLE_EMP = "ROLE_EMP";
export const ROLE_EMP_TL = "ROLE_EMP_TL";
export const ROLE_EMP_DATA = "ROLE_EMP_DATA";
export const ROLE_EMP_ADMIN = "ROLE_EMP_ADMIN";
export const ROLE_AUDITING = "ROLE_AUDITING";
export const ROLE_AUDITING_ADMIN = "ROLE_AUDITING_ADMIN";
export const ROLE_FRA_OB_OBSERVER = "ROLE_FRA_OB_OBSERVER";
export const ROLE_ADMIN = "ROLE_ADMIN";
export const ROLE_SUPERUSER = "ROLE_SUPERUSER";
export const ROLE_NO_FRA_ROLE = "ROLE_NO_FRA_ROLE";
export const ROLE_NO_CS_ROLE = "ROLE_NO_CS_ROLE";
export const ROLE_DB_REPLICATOR = "ROLE_DB_REPLICATOR";
export const ROLE_DB_REPLICATOR_ADMIN = "ROLE_DB_REPLICATOR_ADMIN";
export const ROLE_NO_COMP_ROLE = "ROLE_NO_COMP_ROLE";
export const ROLE_CUST_SUPP_STATISTICS = "ROLE_CUST_SUPP_STATISTICS";
export const ROLE_TRANSPARENCY_ADMIN = "ROLE_TRANSPARENCY_ADMIN";
export const ROLE_TRANSPARENCY = "ROLE_TRANSPARENCY";
export const ROLE_DATAMANAGER = "ROLE_DATAMANAGER";
export const ROLE_DATAMANAGER_ADMIN = "ROLE_DATAMANAGER_ADMIN";
export const ROLE_CLEARING_ADMIN = "ROLE_CLEARING_ADMIN";
export const ROLE_CLEARING = "ROLE_CLEARING";
export const ROLE_CLEARING_SDI_ADMIN = "ROLE_CLEARING_SDI_ADMIN";
export const ROLE_CLEARING_SDI = "ROLE_CLEARING_SDI";
export const ROLE_FRA_OPERATOR = "ROLE_FRA_OPERATOR";
export const ROLE_FRA_OB_ADMIN = "ROLE_FRA_OB_ADMIN";
export const ROLE_CONSERVATION_ADMIN = "ROLE_CONSERVATION_ADMIN";